import { render } from "./FinalGallery.vue?vue&type=template&id=223f2266&scoped=true"
import script from "./FinalGallery.vue?vue&type=script&lang=js"
export * from "./FinalGallery.vue?vue&type=script&lang=js"

import "./FinalGallery.vue?vue&type=style&index=0&id=223f2266&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-223f2266"

export default script